"use strict";

var processInclude = require("./util");
// eslint-disable-next-line no-undef
$(document).ready(function () {
    // eslint-disable-next-line no-undef
    if ($(".page").data("backToScrollEnabled")) {
        processInclude(require("./utils/pages"));
    }
});
